import { useRef, useState, type FC } from "react";
import { ComponentBaseContainer, WordHeaderContainer, WordSummaryContainer } from "./WordCounter.style";
import SideNav from "../nav/SideNav";
import { ComponentContainer, JsonTextContainer, StyledClearIcon, StyledCopyIcon } from "../jsonformatter/JsonFormatter.style";
import Divider from "@mui/material/Divider";
import AdsComponent from "../AdsComponent";
import { Helmet } from "react-helmet-async";

const WordCounter: FC = () => {
    const editorRef = useRef<any>(null);
    const [char, setChar] = useState<number>(0);
    const [word, setWord] = useState<number>(0);
    const [sentance, setSentance] = useState<number>(0);
    const [showToast, setShowToast] = useState(false);


    const countMetric = (val: string) => {
        setChar(val.replace(/(\r\n|\r|\n)/g, '').replace(/\uFEFF/g, '').length)
        setWord(val.trim().split(/\s+/).filter(s => s.length > 0).length)
        setSentance(val.trim().split(/(?<=[.!?])\s+/).filter(s => s.trim().length > 0).length)
    }

    const handleClear = () => {
        editorRef.current?.editor?.setValue("", -1);
    }
    const handleCopy = () => {
        const content = `Characters: ${char}, Words: ${word}, Sentances: ${sentance}`;
        content && navigator.clipboard.writeText(content)
            .then(() => {
                setShowToast(true);
                setTimeout(() => setShowToast(false), 1000);
            })
    }

    return (
        <ComponentBaseContainer>
            <Helmet>
                <title>Word Counter Online | Count Words, Characters, Sentences</title>
                <meta name="description" content="Free word counter tool to count words, characters, and sentences in real time. Great for writing, SEO, and editing." />
                <meta name="keywords" content="word counter, character count, sentence counter, online text analyzer" />
            </Helmet>

            <SideNav />
            <ComponentContainer>
                <WordSummaryContainer>
                    <StyledClearIcon onClick={handleClear} />
                    <JsonTextContainer
                        ref={editorRef}
                        placeholder="Type (or) paste something here..."
                        mode="text"
                        name="text-editor"
                        wrapEnabled
                        onChange={(val) => countMetric(val)}
                        setOptions={{
                            useWorker: false,
                            showLineNumbers: true,
                            tabSize: 2,
                        }}
                    />
                </WordSummaryContainer>
                <Divider orientation="vertical" />
                <WordHeaderContainer>
                    <div style={{ fontSize: "35px", display: "flex" }}>Summary
                        <div style={{ margin: "5px" }}>
                            <StyledCopyIcon onClick={handleCopy} />
                        </div>
                    </div>
                    <Divider style={{ width: "50%", margin: "10px" }} />
                    <div style={{ alignItems: "flex-start", display: "flex", flexDirection: "column", minWidth: "30%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap", marginRight:"5px" }}>
                            <div style={{ minWidth: "50px" }}>Characters</div>
                            <div style={{ margin: "1px" }}>{char}</div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap" }}>
                            <div style={{ minWidth: "50px" }}>Words</div>
                            <div style={{ margin: "1px" }}>{word}</div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap" }}>
                            <div style={{ minWidth: "50px" }}>Sentences</div>
                            <div style={{ margin: "1px" }}>{sentance}</div>
                        </div>
                    </div>

                </WordHeaderContainer>
                {showToast && (
                    <div style={{
                        position: "absolute",
                        top: "10px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        background: "#323232",
                        color: "white",
                        padding: "8px 16px",
                        borderRadius: "6px",
                        opacity: 0.9,
                        fontSize: "14px",
                    }}>
                        Copied to clipboard!
                    </div>
                )}
            </ComponentContainer>
            <AdsComponent />
        </ComponentBaseContainer>
    )
}

export default WordCounter;